import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto text-center" data-id="element-43">
        <div className="w-20 h-20 bg-[#F5F1EA] rounded-full flex items-center justify-center mx-auto mb-6 text-[#5C6B60]" data-id="element-44">
          <ShieldCheck className="w-10 h-10" data-id="element-45" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-6" data-id="element-46">
          Garantía Blindaje Emocional
        </h2>

        <p className="text-lg text-[#4A5568] leading-relaxed mb-8" data-id="element-47">
          Si aplicas el sistema durante 21 días y no ves un cambio en la actitud
          de tu hijo hacia la lectura, te devolvemos el 100% de tu dinero. Sin
          preguntas incómodas.
        </p>

        <p className="text-sm text-[#8B6F5C] italic" data-id="element-48">
          Queremos que tu única preocupación sea disfrutar el proceso con tu
          hijo.
        </p>
      </div>
    </section>;
}